import {useConfig, useUser} from './auth'
import {Link, useLocation} from 'react-router-dom'
import { useSelector } from 'react-redux'

function NavBarItem(props) {
    const location = useLocation()
    const isActive = (props.href && location.pathname.startsWith(props.href)) || (props.to && location.pathname.startsWith(props.to))
    const cls = isActive ? 'nav-link active' : 'nav-link'
    return (
        <p style={{ margin: '5px 0' }}>
            {props.href
                ? <a className={cls} href={props.href}>{props.icon} {props.name}</a>
                : <Link className={cls} to={props.to}>{props.icon} {props.name}</Link>}
        </p>
    )
}

export default function AuthNavBar() {
    const user = useUser()
    const config = useConfig()
    const permissions = useSelector(state => state.permissions)
    
    const anonNav = (
        <>
            <NavBarItem to='/login' icon='🔑' name='Login'/>
        </>
    )
    const authNav = (
        <>
            <NavBarItem to='/account/password/change' icon='🔒' name='Change Password'/>
            {config.data.mfa && permissions.mfa_enabled === true
                ? <NavBarItem to='/account/2fa' icon='📱' name='Two-Factor Authentication'/>
                : null}
            <NavBarItem to='/account/logout' icon='👋' name='Logout'/>
        </>
    )
    return (
        <nav>
            {user ? authNav : anonNav}
        </nav>
    )
}
